import { SharedModule } from "../../../core/shared/shared.module";
import { userDetailsRouting } from "./user-details.routing";
import { UserDetailsRest } from "./user-details.rest";
import { NgModule } from "@angular/core";
import { UserDetailsComponent } from "./user-details.component";
import { UserDetailsHeaderComponent } from "./header/user-details-header.component";
import { UserDetailsPositionsComponent } from "./positions/user-details-positions.component";
import { UserDetailsPositionComponent } from "./positions/user-details-position.component";
import { NotTheSameValidatorDirective } from "./password-the-same";
import { IssuesRest } from "../../../issues/issues.rest";

@NgModule({
    imports: [SharedModule, userDetailsRouting],
    exports: [UserDetailsPositionComponent],
    declarations: [
        NotTheSameValidatorDirective,
        UserDetailsComponent, UserDetailsHeaderComponent, UserDetailsPositionsComponent, UserDetailsPositionComponent],
    providers: [UserDetailsRest, IssuesRest]
})

export class UserDetailsModule { }